// extracted by mini-css-extract-plugin
export var animationContainer = "_hd-0";
export var asteriskIcon = "_hd-8";
export var conversationLeftSection = "_hd-4";
export var conversationListItem = "_hd-3";
export var conversationMiddleSection = "_hd-5";
export var conversationRightSection = "_hd-6";
export var detailsContent = "_hd-1";
export var listContainer = "_hd-7";
export var modalContent = "_hd-2";